<template>
  <div>
    <el-transfer v-model="selected" :titles="[$t('card.packages'),$t('card.packagesSelected')]" :props="{key:'id',label:'desc'}" :data="allItems" style="width:100%">
    </el-transfer>
    <el-button class="transfer-footer" slot="left-footer" size="small" @click="handleUpdate">更新</el-button>
  </div>
</template>

<script>

import { fetchPackageList } from '../api/package'
export default {
  data () {
    return {
      selected: [],
      allItems: []
    }
  },
  created () {
    fetchPackageList({limit: 0}).then((res) => {
      this.allItems = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  mounted () {
    this.selected = this.value
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate () {
      fetchPackageList({limit: 0}).then((res) => {
        this.allItems = res.data.map((item) => { item.id = parseInt(item.id); return item })
      })
    }
  },
  watch: {
    selected (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.selected = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/PackagesSelect.vue